// NOTE: Bu metin bir taslaktır. Hukuki kontrol önerilir.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function ExplicitConsent() {
  return (
    <LegalPage
      title="Açık Rıza Metni"
      subtitle="Pazarlama iletişimi ve analitik/pazarlama çerezleri için verdiğiniz açık rıza hakkında bilgi."
      lastUpdated="Mayıs 2026"
      version={LEGAL_VERSIONS.marketing}
      testid="consent-page"
    >
      <h2>1. Açık Rızanın Kapsamı</h2>
      <p>
        uSeen ürün güncellemeleri, kampanyaları ve eğitim içeriklerini e-posta ile
        alabilmemiz için açık rızanıza ihtiyaç duyulur. Kayıt formunda{" "}
        <strong>"uSeen ürün güncellemeleri, kampanya ve pazarlama e-postaları almak
        istiyorum"</strong> kutucuğunu işaretleyerek bu rızayı vermiş olursunuz.
      </p>

      <h2>2. Pazarlama İzni Olmadan da Hizmet Kullanılabilir</h2>
      <p>
        <strong>Üyeliğiniz pazarlama iznine bağlı değildir.</strong> Bu izni vermeden de
        uSeen platformunu eksiksiz biçimde kullanabilirsiniz; rızanın varlığı yalnızca
        pazarlama amaçlı iletişim göndermemize olanak verir.
      </p>

      <h2>3. Analitik ve Pazarlama Çerezleri</h2>
      <p>
        Açık rıza vermeniz durumunda; hangi sayfaların ne kadar süre ziyaret edildiğini
        anonim biçimde ölçmek için analitik çerezleri ve ilgi alanlarınıza uygun ürün
        iletişimi sağlayabilmek için pazarlama çerezleri kullanılabilir. Detaylar için{" "}
        <a href="/cerez-politikasi">Çerez Politikası</a> sayfasını inceleyebilirsiniz.
      </p>

      <h2>4. Rızanın Geri Alınması</h2>
      <p>
        Verdiğiniz açık rızayı dilediğiniz an geri alabilirsiniz. Bunun için:
      </p>
      <ul>
        <li>Hesap ayarlarınızdan pazarlama izninizi kapatabilirsiniz</li>
        <li>Aldığınız her e-postanın altındaki "Listeden çık" bağlantısını kullanabilirsiniz</li>
        <li>Veya doğrudan <a href="/iletisim">iletişim sayfası</a> üzerinden bize bildirebilirsiniz</li>
      </ul>
      <p>
        Rızanızı geri aldığınız andan itibaren işleme faaliyeti durdurulur. Rıza geri
        alınmadan önce yapılan işlemler bu durumdan etkilenmez.
      </p>

      <h2>5. Saklama Süresi</h2>
      <p>
        Verdiğiniz açık rıza ve geri alma tarihleri, hukuki uyum yükümlülüklerimiz
        kapsamında belirli bir süre boyunca saklanır.
      </p>

      <h2>6. İletişim</h2>
      <p>
        Açık rıza süreçleri hakkında sorularınız için <a href="/iletisim">iletişim sayfası</a>
        üzerinden bize ulaşabilirsiniz.
      </p>
    </LegalPage>
  );
}
